<template>
    <ul class="flex list-reset border border-grey-light rounded w-auto font-sans">
        <li v-if="pagination.CurrentPage > 1">
            <a class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2" 
                href="#"
                @click.prevent="change(pagination.CurrentPage -1)"
            >
                Anterior
            </a>
        </li>
        <li v-for="page in pages" :key="page" >
            <a :class="[page == pagination.CurrentPage ? 'text-white bg-blue border-r border-blue':'hover:text-white hover:bg-blue text-blue border-r border-grey-light', 'block px-3 py-2']" 
               href="#"
               @click.stop="change(page)"
            >
                {{ page }}
            </a>
        </li>
        <li v-if="pagination.CurrentPage < pagination.TotalPages">
            <a class="block hover:text-white hover:bg-blue text-blue px-3 py-2" 
               href="#"
               @click.prevent="change(pagination.CurrentPage + 1)"
            >
                Próximo
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            pagination: {
                type: Object,
                required: true
            },
            offset: {
                type: Number,
                default: 4
            }
        },

        computed: {
            pages() {
                // if (!this.pagination.to) {
                //     return null;
                // }

                let from = this.pagination.CurrentPage - this.offset;
                if (from < 1) {
                    from = 1;
                }

                let to = from + (this.offset * 2);
                if (to >= this.pagination.TotalPages) {
                    to = this.pagination.TotalPages;
                }

                let pages = [];
                for (let page = from; page <= to; page++) {
                    pages.push(page);
                }

                return pages;
            },
        },

        methods: {
            change: function(page) {
                this.pagination.CurrentPage = page;
                this.$emit('paginate');
            }
        }
    }
</script>